import React from 'react';
import { Box, LinearProgress } from '@mui/material';

interface RouteLoadingFallbackProps {
  fullScreen?: boolean;
}

const RouteLoadingFallback: React.FC<RouteLoadingFallbackProps> = ({ fullScreen = false }) => (
  <Box
    role="progressbar"
    aria-label="Carregando"
    sx={{
      position: fullScreen ? 'fixed' : 'relative',
      top: 0,
      left: 0,
      right: 0,
      zIndex: fullScreen ? 2000 : 1,
      flex: fullScreen ? undefined : 1,
      minHeight: fullScreen ? undefined : 0,
    }}
  >
    <LinearProgress sx={{ height: 2, bgcolor: 'transparent', '& .MuiLinearProgress-bar': { bgcolor: '#0D9488' } }} />
  </Box>
);

export default RouteLoadingFallback;
